import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AGENT_ALLIANCE_APPLICATIONS_QUERY_KEY } from './useFetchAllianceApplications';
import { AGENT_ALLIANCE_APPLICATION_DETAIL_QUERY_KEY } from './useFetchAgentAllianceApplicationDetail';

interface UpdateCompanyAssigneesParams {
  companyId: number;
  organizationUserIds: number[];
}

export default function useUpdateAllianceCompanyAssignees() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ companyId, organizationUserIds }: UpdateCompanyAssigneesParams) => {
      const response = await fetch(`/agent/api/companies/${companyId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify({ organization_user_ids: organizationUserIds }),
      });

      if (!response.ok) {
        let errorMessage = '担当者の更新に失敗しました';
        try {
          const errorData = await response.json();
          errorMessage = errorData.errors?.join(', ') || errorData.message || errorMessage;
        } catch {
          // JSONパースに失敗した場合はデフォルトメッセージを使用
        }
        throw new Error(errorMessage);
      }

      return response.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: AGENT_ALLIANCE_APPLICATIONS_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: AGENT_ALLIANCE_APPLICATION_DETAIL_QUERY_KEY });
    },
  });
}
